import { AxiosRequestConfig } from 'axios';
import { URL_BACKEND_ROOT } from "../app/AppConst";
import { DeliveryZoneEntity } from "../dto/deliveryzone/DeliveryZoneEntity";
import { ReadResponse } from '../dto/response/ReadResponse';
import { BaseResponse } from '../dto/response/BaseResponse';
import { ApiClient } from '../util/ApiUtility';
import { DeliveryZoneSearch } from '../dto/deliveryzone/DeliveryZoneSearch';

export const onDeliveryZoneSearch = async (data: DeliveryZoneSearch) => {
  const requestConfig: AxiosRequestConfig = {
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
    url: `${URL_BACKEND_ROOT}/v1/cms/delivery-zone`,
    params: {
      id: data.id,
      name: data.name,
      status: data.status,
      offset: data.offset,
      limit: data.limit,
    },
  };
  const response = await ApiClient().request<ReadResponse>(requestConfig);
  if (response.status >= 200 && response.status < 300) return response.data;
  throw new Error("Амжилтгүй");
};

export const deliveryZoneCreate = async (zone: DeliveryZoneEntity) => {
  const requestConfig: AxiosRequestConfig = {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}/v1/cms/delivery-zone/create`,
    data: zone,
  };
  const response = await ApiClient().request<BaseResponse<DeliveryZoneEntity>>(requestConfig);
  if (response.status >= 200 && response.status < 300) return response.data;
  throw new Error("Амжилтгүй");
};

export const deliveryZoneUpdate = async (zone: DeliveryZoneEntity) => {
  const requestConfig: AxiosRequestConfig = {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}/v1/cms/delivery-zone/update`,
    data: zone,
  };
  const response = await ApiClient().request<BaseResponse<DeliveryZoneEntity>>(requestConfig);
  if (response.status >= 200 && response.status < 300) return response.data;
  throw new Error("Амжилтгүй");
};